import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormArray, FormBuilder, FormControl, UntypedFormGroup } from '@angular/forms';
import { LifecycleService } from 'src/app/shared/services/lifecycle.service';

@Component({
    selector: 'app-task-workflow-step',
    templateUrl: './task-workflow-step.component.html',
    styleUrls: ['./task-workflow-step.component.scss'],
    standalone: false
})
export class TaskWorkflowStepComponent implements OnInit {
  @Input() taskData: any
  @Output() taskFormChange = new EventEmitter<any>();
  @Input() participants: string[] = [];
  @Input() workflowId: number;
   taskStepForm:UntypedFormGroup;

  // participants = ['Manager', 'QC Reviewer', 'Data Entry'];
  templates = ['Task Assigned Email', 'Reminder Email'];

  availableFields = [
    // 'Case Number',
    // 'Age Group',
    // 'Customer Name',
    // 'Policy Number'
  ];

 constructor(private fb: FormBuilder,private lifecycleservice:LifecycleService) {}
 /**
   * @Author Shyam
   * @Date 26/03/2026
   *  @Description: Task workflow steps Component
   */
  ngOnInit() {
    this.formValidations()
    console.log(this.workflowId)
    
    console.log(this.taskStepForm.controls);
    this.lifecycleservice.retrieveJSuiteObjectsByWorkflowAndLifecycleId(this.workflowId).subscribe((response)=>{
      console.log(response)
      if(response){
          const attributes = JSON.parse(response.attributes)
          console.log(attributes)
          this.availableFields = attributes.map((fields :any) => fields.Field)
          console.log(this.availableFields)
      }else{
        console.log("No object found", this.workflowId);
      }
    })
     if (this.taskData) {
    this.loadData();
  }
    
  }
  
  ngOnChanges(changes: SimpleChanges): void {
  if (changes['taskData'] && this.taskStepForm) {
    this.loadData();
  }
}

  formValidations() {

    this.taskStepForm = new UntypedFormGroup({

      taskLabel: new FormControl(''),
      description: new FormControl(''),

      assignTo: new FormControl(''),
      assignmentType: new FormControl('ALL'),

      instructions: new FormControl(''),

      enableVerdicts: new FormControl(false),

      verdicts: this.fb.array([
        // this.createVerdict(),
        // this.createVerdict()
      ]),

      promptComments: new FormControl(false),
      promptFields: new FormControl(false),

      dueDateType: new FormControl('TASK_CREATED'),
      offsetDays: new FormControl(1),

      notificationTemplate: new FormControl(''),
      addComments: new FormControl(false),
      addCapacities: new FormControl(false),
      addESignature:  new FormControl(false),
      addReasons:  new FormControl(false),
      addFieldPrompts: new FormControl(false),
      addParticipants: new FormControl(false),
      commentLabel: new FormControl(''),
      promptParticipants: new FormControl(false),
      fields: this.fb.array([]),
      participantsArray: this.fb.array([]),
      commentRequired: new FormControl(false),

    });

  }

  createVerdict() {
    return this.fb.group({
      label: ['']
    });
  }

  addVerdict() {
    this.verdicts.push(this.createVerdict());
  }

  removeVerdict(index: number) {
    this.verdicts.removeAt(index);
  }

    get fields(): FormArray {
    return this.taskStepForm.get('fields') as FormArray;
  }

  get verdicts(): FormArray {
    return this.taskStepForm.get('verdicts') as FormArray;
  }

  get participantsArray(): FormArray {
    return this.taskStepForm.get('participantsArray') as FormArray;
  }


addField() {
  
  const fieldGroup = this.fb.group({
    fieldName: [''],
    required: [false]
  });

  this.fields.push(fieldGroup);

}
  removeField(index: number) {
    this.fields.removeAt(index);
  }

  /* -------------------------
      PARTICIPANTS
  -------------------------- */

 addParticipant(){ this.participantsArray.push( this.fb.group({ participant:[''] }) ); }

  removeParticipant(index: number) {
    this.participantsArray.removeAt(index);
  }

  getFormData() {
  const form = this.taskStepForm.value;

  // Filter out empty fields
  const fields = (form.promptFields ? form.fields : [])
    .filter(f => f.fieldName && f.fieldName.trim() !== "");

  const participants = (form.promptParticipants ? form.participantsArray : [])
    .filter(p => p.participant && p.participant.trim() !== "");

  const verdicts = (form.enableVerdicts ? form.verdicts : [])
    .filter(v => v.label && v.label.trim() !== "");

  return {
    stepType: 'TASK',
    taskConfig: {
      assignment: {
        type: form.assignmentType,
        assignee: form.assignTo
      },
      taskLabel: form.taskLabel,
      instructions: form.instructions,
      dueDate: {
        basedOn: form.dueDateType,
        offsetDays: form.offsetDays
      },
      notification: {
        template: form.notificationTemplate
      },
      prompts: {
        comments: {
          enabled: form.promptComments,
          label: form.commentLabel,
          required: form.commentRequired
        },
        fields: fields,
        participants: participants,
        verdicts: verdicts
      }
    }
  };
}
  
  loadData() {
  if (!this.taskData) return;

  console.log('TASK EDIT DATA:', this.taskData);

  //  Patch normal fields
  // this.taskStepForm.patchValue(this.taskData);
  const config = this.taskData?.taskConfig
  const prompts = config?.prompts
  this.taskStepForm.patchValue({
    assignTo:config?.assignment.assignee,
    assignmentType    : config?.assignment.type,
    instructions      : config?.instructions,
    taskLabel         : config?.taskLabel,
    dueDate           :config?.dueDate.dueDateType,
    offsetDays        :config?.dueDate.offsetDays,
    notificationTemplate:config?.notification.template,
    promptComments    :prompts?.comments.enabled,
    commentLabel      :prompts?.comments.label,
    commentRequired: prompts?.comments?.required,
    promptFields: (prompts?.fields?.length ?? 0) > 0,
    promptParticipants: (prompts?.participants?.length ?? 0) > 0,
    enableVerdicts: (prompts?.verdicts?.length ?? 0) > 0


  })

  //  Handle FormArrays manually
  this.setFields(prompts?.fields);
  this.setParticipants(prompts?.participants);
  this.setVerdicts(prompts?.verdicts);
  }
  setFields(fields: any[]) {
  this.fields.clear();

  if (fields?.length) {
    fields.forEach(f => {
      this.fields.push(
        this.fb.group({
          fieldName: [f.fieldName],
          required: [f.required]
        })
      );
    });
  }
  }
  setParticipants(data: any[]) {
  this.participantsArray.clear();

  if (data?.length) {
    data.forEach(p => {
      this.participantsArray.push(
        this.fb.group({
          participant: [p.participant]
        })
      );
    });
  }
  }
  setVerdicts(data: any[]) {
  this.verdicts.clear();

  if (data?.length) {
    data.forEach(v => {
      this.verdicts.push(
        this.fb.group({
          label: [v.label]
        })
      );
    });
  }
  }
  
}
